import { FC } from "react";
import CustomAlert from "@dashboard/components/custom-alert/custom-alert";
import { parseBoldMarkedText } from "../../utils/delivery-create.utils";
import {
  DeliveryCreateHelpText,
  DeliveryCreateHelpWrapper,
} from "./delivery-create-help.styled";

type DeliveryProductsAlertProps = {
  message: string;
};

export const DeliveryProductsAlert: FC<DeliveryProductsAlertProps> = ({
  message,
}) => {
  const parts = parseBoldMarkedText(message);

  return (
    <CustomAlert
      description={
        <>
          {parts.map((part, index) =>
            part.bold ? (
              <strong key={index}>{part.text}</strong>
            ) : (
              <span key={index}>{part.text}</span>
            )
          )}
        </>
      }
    />
  );
};

type DeliveryHtmlHelpTextProps = {
  html: string;
  className?: string;
};

export const DeliveryHtmlHelpText: FC<DeliveryHtmlHelpTextProps> = ({
  html,
  className,
}) => (
  <DeliveryCreateHelpText
    className={className}
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

type DeliverySizeHelpTextsProps = {
  helpText1?: string;
  helpText2?: string;
};

export const DeliverySizeHelpTexts: FC<DeliverySizeHelpTextsProps> = ({
  helpText1,
  helpText2,
}) => {
  if (!helpText1 && !helpText2) return null;

  return (
    <DeliveryCreateHelpWrapper>
      {helpText1 && <p className="help-text-regular">{helpText1}</p>}
      {helpText2 && <p className="help-text-semibold">{helpText2}</p>}
    </DeliveryCreateHelpWrapper>
  );
};
